import React from "react";
import { UserCircle2 } from "lucide-react";
import { useUser } from "../context/UserContext";
import { useRestaurant } from "../context/RestaurantContext";

const Header = ({ restaurantName }) => {
    const { user } = useUser();
    const { restaurant } = useRestaurant();
    const displayName = user?.first_name || user?.username || null;
    const name = restaurantName || restaurant?.name || "";

    return (
        <header className="w-full px-4 py-2.5 bg-white border-b border-gray-100 sticky top-0 z-50">
            <div className="max-w-screen-xl mx-auto flex items-center justify-between gap-4">
                <span className="text-base font-bold text-gray-900 truncate">{name}</span>

                {displayName && (
                    <div className="flex items-center gap-1.5 shrink-0">
                        <UserCircle2 size={16} className="text-brandBlue" />
                        <span className="text-xs font-medium text-gray-600 max-w-[100px] truncate">
                            {displayName}
                        </span>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;